"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftOtrDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const common_1 = require("./common");
class NftOtrDataset extends common_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.purchase = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.NFT_PURCHASE }));
        this.bid = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign(Object.assign({}, params), { requestType: interfaces_1.TangleRequestType.NFT_BID }));
        this.setForSale = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.NFT_SET_FOR_SALE }, params));
        this.mintMetadataNft = (params) => new common_1.OtrRequest(this.otrAddress, Object.assign({ requestType: interfaces_1.TangleRequestType.MINT_METADATA_NFT }, params));
    }
}
exports.NftOtrDataset = NftOtrDataset;
